import { CheckBadgeIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/20/solid';
import _ from 'lodash';
import { useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as EMPLOYEEACTIONS } from '../../store/actions/employeeActions';
import { Actions as LEAVEACTIONS } from '../../store/actions/leaveActions';
import Spinner from '../common/Spinner';
import { validateFloat } from "../common/validation/Validators";
import LeaveCarryoverRow from "./LeaveCarryoverRow";

const LeaveCarryoverModal = ({
  isModalOpen,
  closeModal,
  employees,
  setMaxCarryover,
  carryoverValues,
  saveCarryover,
  areValid,
  applyingCarryover,
  getLeaveBalance,
  leaveBalancesUpdating
}) => {
  const referenceYear = new Date().getFullYear() - 1

  useEffect(() => {
    if (!isModalOpen) return
    getLeaveBalance(`${referenceYear}-12-31`);
  }, [isModalOpen])

  if (!isModalOpen) return null

  const maxCarryover = carryoverValues?.maxCarryover
  const maxPayable = carryoverValues?.maxPayable

  const carryNone = () => setMaxCarryover(0, 0, false)
  const carryAll = () => setMaxCarryover(1080, 0, true)

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog" style={{ width: "65%", background: "white" }}>
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={closeModal}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                </li>
              </ul>
              <h3 className="block-title">Leave Carryover</h3>
            </div>
            <div className="block-content">
              {leaveBalancesUpdating ?
                <></>
                :
                <>
                  <div className="col-xs-3 pl-0">
                    <label>Default Hours To Carryover</label>
                    <input
                      className="form-control form-input"
                      onChange={(e) => setMaxCarryover(validateFloat(e.target.value), maxPayable, false)}
                      value={maxCarryover}
                    />
                  </div>

                  <div className="col-xs-3 pl-0">
                    <label>Default Hours To Pay</label>
                    <input
                      className="form-control form-input"
                      onChange={(e) => setMaxCarryover(maxCarryover || 0, validateFloat(e.target.value), false)}
                      value={maxPayable}
                    />
                  </div>
                  <div className="col-xs-6 pr-0" style={{ paddingTop: 24 }}>
                    <div
                      className="btn btn-default pull-right"
                      onClick={carryAll}
                    >
                      Carryover All
                    </div>
                    <div
                      className="btn btn-default pull-right"
                      style={{ marginRight: 10 }}
                      onClick={carryNone}
                    >
                      Carryover None
                    </div>
                  </div>
                  <div className="clearfix" />
                  <div style={{ maxHeight: "50vh", overflow: "auto" }}>
                    <table id="table-timesheets" className="js-table-sections table table-hover" >
                      <thead>
                        <tr>
                          <th>Team Member</th>
                          <th title={`VL Balance`}>{`VL Balance`}</th>
                          <th title={`Carry Forward`}>{`Carry Forward`}</th>
                          <th title={`To Pay`}>{`To Pay`}</th>
                          <th title={`Forfeited`}>{`Forfeited`}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {employees.map(employee => (<LeaveCarryoverRow key={employee.id} employee={employee} />))}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-xs-12 pr-0 form-container">
                    <div
                      className={`btn ${areValid ? "btn-success" : "btn-danger"} pull-right`}
                      onClick={() => { if (areValid) saveCarryover() }}
                    >
                      {applyingCarryover ?
                        <Spinner
                          style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                          className="animate-spin -ml-1 mr-3 h-5 w-5 "
                        />
                        :
                        areValid ?
                          <CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                          :
                          <ExclamationTriangleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                      }
                      <div style={{ float: "left" }}>
                        {applyingCarryover ? 'Carrying Over Leave' : areValid ? 'Carryover Leave' : 'Invalid Leave Carryover'}
                      </div>
                    </div>
                  </div>
                  <div className="clearfix" />
                </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {

  const employeeListWithSalary = state?.employees?.employeeListWithSalary
  const sortedEmployees = _.orderBy(employeeListWithSalary, ["employeeName", "employeeSurname"], ["asc", "asc"])
  const carryover = state?.employees?.carryover
  const areValid = carryover && Object.keys(carryover)?.find(item =>
    carryover[item].isValid == false
  )?.length > 0 ? false : true


  return {
    employees: sortedEmployees,
    isModalOpen: state?.leave?.leaveCarryoverModal,
    carryoverValues: state?.leave?.leaveCarryoverMax,
    leaveBalancesUpdating: state?.leave?.leaveBalancesUpdating,
    applyingCarryover: state?.employees?.applyingCarryover,
    carryoverApplied: state?.employees?.carryoverApplied,
    areValid,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(LEAVEACTIONS.leaveCarryoverModal(false)),
  saveCarryover: () => dispatch(EMPLOYEEACTIONS.saveCarryover()),
  setMaxCarryover: (maxCarryover, maxPayable, carryoverAll) => dispatch(LEAVEACTIONS.setMaxCarryover(maxCarryover, maxPayable, carryoverAll)),
  getLeaveBalance: (date) => dispatch(LEAVEACTIONS.leaveGetBalances(date)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaveCarryoverModal)